import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { IDataToken, IUser } from '../../interfaces/toolbar/toolbar.interface';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, Subject } from 'rxjs';
const jwt = new JwtHelperService();

@Injectable({
  providedIn: 'root',
})
export class InfoTokenService {
  private dataUserSubject = new Subject<IUser>();
  getUserDataObsevable = this.dataUserSubject.asObservable();
  constructor(private cookieService: CookieService) {
    if (this.getUserData() && this.getUserData()?.username) {
      this.dataUserSubject.next(this.getUserData());
    }
  }

    setToken(token: string, refreshToken: string = '') {
    const domain = this.getDomain();
    this.cookieService.set('auth_key', token, 24, '/', domain.domain);
    this.cookieService.set('auth_refesh', refreshToken, 24, '/', domain.domain);
    this.cookieService.set(
      'authTimeOut',
      new Date().getTime().toString(),
      24,
      '/',
      domain.domain
    );
  }

  setName(name: string) {
    const domain = this.getDomain();
    this.cookieService.set('name', name, 24, '/', domain.domain);
  }

  setUserData(user: IUser) {
    this.dataUserSubject.next(user);
    const domain = this.getDomain();
    this.cookieService.set(
      'userData',
      JSON.stringify(user),
      24,
      '/',
      domain.domain
    );
  }

  /**
   * Get Name
   *
   * @return {string}
   */
  getUserData(): IUser {
    return JSON.parse(this.cookieService.get('userData') || '{}');
  }

  /**
   * Get Name
   *
   * @return {string}
   */
  getName(): string {
    return this.cookieService.get('name') || '';
  }

  /**
   * Get Token
   *
   * @return {string}
   */
  getToken(): string {
    return this.cookieService.get('auth_key');
  }
  getResfreshToken(): string {
    return this.cookieService.get('auth_refesh');
  }
  /**
   * Get Data Token
   *
   *
   */
  getDataToken(): IDataToken {
    const token = this.getToken();
    return jwt.decodeToken(token) as IDataToken;
  }

  /**
   * Remove Token
   */
  removeToken() {
    const domain = this.getDomain();
    this.cookieService.delete('auth_key', '/', domain.domain);
    this.cookieService.delete('auth_refesh', '/', domain.domain);
    this.cookieService.delete('authTimeOut', '/', domain.domain);
    this.cookieService.delete('roles', '/', domain.domain);
    this.cookieService.deleteAll('/', domain.domain);
    this.cookieService.deleteAll('/');
  }

  getDomain() {
    const host = document.location.hostname;
    const firstDotIndex = host.indexOf('.');
    const domain = host.substring(firstDotIndex);
    return {
      domain: domain.split('/')[0],
    };
  }

  countChart(cadena: string, search: string): number[] {
    let indices = [];
    for (let i = 0; i < cadena.length; i++) {
      if (cadena[i].toLowerCase() === search) indices.push(i);
    }
    return indices;
  }
}
